export default function CategoryFilters({ categories, active, onChange }) {
  const all = ["All", ...categories];
  return (
    <div className="flex flex-wrap gap-3" data-testid="category-filters">
      {all.map((c) => (
        <button
          key={c}
          onClick={() => onChange(c)}
          className={`pw-pill ${active === c ? "active" : ""}`}
          data-testid={`category-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
